var C = Object.defineProperty;
var g = (e, t, r) => t in e ? C(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r;
var h = (e, t, r) => g(e, typeof t != "symbol" ? t + "" : t, r);
import { LOGGER as O, COOKIE_SERVICE as S } from "@packages/common";
import { CONFIG as v } from "@packages/config";
import { Injectable as f, Inject as s } from "@webmotors/ioc";
import "./main18.js";
import { COOKIE_CONSENTS_SERVICE as _ } from "./main19.js";
import { LAST_SEARCH_SERVICE as E } from "./main25.js";
var k = Object.getOwnPropertyDescriptor, m = (e, t, r, o) => {
  for (var i = o > 1 ? void 0 : o ? k(t, r) : t, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (i = n(i) || i);
  return i;
}, c = (e, t) => (r, o) => t(r, o, e);
let l = class {
  constructor(e, t, r, o) {
    h(this, "COOKIE_NAME");
    h(this, "logger");
    this.config = e, this.loggerFactory = t, this.cookieService = r, this.cookieConsentsService = o, this.logger = this.loggerFactory.create(E), this.COOKIE_NAME = this.config.lastSearchCookieName || "";
  }
  clearAll() {
    this.logger.log("[clearAll] clearing search cookies: ", this.COOKIE_NAME), this.cookieService.removeCookie(this.COOKIE_NAME);
  }
  /**
   * Save the most recent search URL in the cookie for the specified vehicle type.
   *
   * @param url - The URL to be saved in the cookie.
   */
  async save(e) {
    try {
      if (!this.COOKIE_NAME || !e || !await this.cookieConsentsService.isSearchEnabled())
        return;
      const t = this.getVehicleType(e);
      if (!t)
        return;
      const r = this.get();
      if (!r) {
        const i = { [t]: e };
        this.cookieService.save(this.COOKIE_NAME, i);
        return;
      }
      if (r[t] === e || !r || r[t] === e)
        return;
      const o = {
        ...r,
        [t]: e
      };
      this.cookieService.save(this.COOKIE_NAME, o);
    } catch (t) {
      this.logger.error("[Set] Failed to set lastSearchCookie.", t);
    }
  }
  /**
   * Return the most recent search URL from the cookie for the specified key.
   *
   * @param key - The key to retrieve the URL for.
   * @returns The most recent search URL from the cookie, or null if not found.
   */
  get() {
    try {
      const e = this.cookieService.get(
        this.COOKIE_NAME
      );
      return e || null;
    } catch (e) {
      return this.logger.error("[Get] Failed to get lastSearchCookie.", e), null;
    }
  }
  /**
   * Determine the vehicle type based on the given URL.
   *
   * @param url - The URL to determine the vehicle type from.
   * @returns The vehicle type as a {@link CookieKey}, or null if not found.
   */
  getVehicleType(e) {
    return e ? e.startsWith("/motos") || e.search("tipoveiculo=motos") !== -1 ? "bike" : e.startsWith("/carros") || e.search("tipoveiculo=carros") !== -1 ? "car" : null : null;
  }
};
l = m([
  f(E),
  c(0, s(v)),
  c(1, s(O)),
  c(2, s(S)),
  c(3, s(_))
], l);
export {
  l as LastSearchService
};
